import axios from "axios";
import { API_ENDPOINT } from "../config";
import { handleError } from "../libs/apiUtils";

const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
};

// ========== USERS CRUD ==========
export const getAllUsers = async () => {
  try {
    const response = await axios.get(`${API_ENDPOINT}/admin/users`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getUserById = async (id) => {
  try {
    const response = await axios.get(`${API_ENDPOINT}/admin/users/${id}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const updateUser = async (id, userData) => {
  try {
    const response = await axios.put(
      `${API_ENDPOINT}/admin/users/${id}`,
      userData,
      {
        headers: getAuthHeaders(),
      },
    );
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const deleteUser = async (id) => {
  try {
    const response = await axios.delete(`${API_ENDPOINT}/admin/users/${id}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// ========== CHARACTERS CRUD ==========
export const getAllCharacters = async () => {
  try {
    const response = await axios.get(`${API_ENDPOINT}/admin/characters`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getCharacterById = async (id) => {
  try {
    const response = await axios.get(`${API_ENDPOINT}/admin/characters/${id}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const updateCharacter = async (id, characterData) => {
  try {
    const response = await axios.put(
      `${API_ENDPOINT}/admin/characters/${id}`,
      characterData,
      {
        headers: getAuthHeaders(),
      },
    );
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const deleteCharacter = async (id) => {
  try {
    const response = await axios.delete(
      `${API_ENDPOINT}/admin/characters/${id}`,
      {
        headers: getAuthHeaders(),
      },
    );
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// ========== EQUIPMENT TEMPLATES CRUD ==========
export const getAllEquipmentTemplates = async () => {
  try {
    const response = await axios.get(
      `${API_ENDPOINT}/admin/equipment-templates`,
      {
        headers: getAuthHeaders(),
      },
    );
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getEquipmentTemplateById = async (id) => {
  try {
    const response = await axios.get(
      `${API_ENDPOINT}/admin/equipment-templates/${id}`,
      {
        headers: getAuthHeaders(),
      },
    );
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const createEquipmentTemplate = async (equipmentData) => {
  try {
    const response = await axios.post(
      `${API_ENDPOINT}/admin/equipment-templates`,
      equipmentData,
      {
        headers: getAuthHeaders(),
      },
    );
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const updateEquipmentTemplate = async (id, equipmentData) => {
  try {
    const response = await axios.put(
      `${API_ENDPOINT}/admin/equipment-templates/${id}`,
      equipmentData,
      {
        headers: getAuthHeaders(),
      },
    );
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const deleteEquipmentTemplate = async (id) => {
  try {
    const response = await axios.delete(
      `${API_ENDPOINT}/admin/equipment-templates/${id}`,
      {
        headers: getAuthHeaders(),
      },
    );
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// ========== WEAPON TEMPLATES CRUD ==========
export const getAllWeaponTemplates = async () => {
  try {
    const response = await axios.get(`${API_ENDPOINT}/admin/weapon-templates`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getWeaponTemplateById = async (id) => {
  try {
    const response = await axios.get(
      `${API_ENDPOINT}/admin/weapon-templates/${id}`,
      {
        headers: getAuthHeaders(),
      },
    );
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const createWeaponTemplate = async (weaponData) => {
  try {
    const response = await axios.post(
      `${API_ENDPOINT}/admin/weapon-templates`,
      weaponData,
      {
        headers: getAuthHeaders(),
      },
    );
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const updateWeaponTemplate = async (id, weaponData) => {
  try {
    const response = await axios.put(
      `${API_ENDPOINT}/admin/weapon-templates/${id}`,
      weaponData,
      {
        headers: getAuthHeaders(),
      },
    );
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const deleteWeaponTemplate = async (id) => {
  try {
    const response = await axios.delete(
      `${API_ENDPOINT}/admin/weapon-templates/${id}`,
      {
        headers: getAuthHeaders(),
      },
    );
    return response.data;
  } catch (error) {
    handleError(error);
  }
};
